import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface HomeLoanState {
    loanAmount: string;
    interestRate: string;
    loanTerm: string;
    monthlyRepayment: string; // Add monthlyRepayment field
}

const initialState: HomeLoanState = {
    loanAmount: '',
    interestRate: '',
    loanTerm: '30', // Default value for loanTerm is '30'
    monthlyRepayment: '', // Initialize monthlyRepayment as an empty string
};

const homeResultsSlice = createSlice({
    name: 'homeLoanResults',
    initialState,
    reducers: {
        setHomeLoanResultsData: (state, action: PayloadAction<HomeLoanState>) => {
            state.loanAmount = action.payload.loanAmount;
            state.interestRate = action.payload.interestRate;
            state.loanTerm = action.payload.loanTerm;
            state.monthlyRepayment = action.payload.monthlyRepayment; // Handle monthlyRepayment
        },
        clearHomeLoanResultsData: (state) => {
            state.loanAmount = '';
            state.interestRate = '';
            state.loanTerm = '30'; // Resetting to default loan term
            state.monthlyRepayment = ''; // Reset monthlyRepayment
        },
    },
});

export const { setHomeLoanResultsData, clearHomeLoanResultsData } = homeResultsSlice.actions;

export default homeResultsSlice.reducer;
